import * as actionType from "./constants";

const initialState = {
    getLeaseBuildingsResponse: [],
    addLeaseBuildingsResponse: null,
    updateLeaseBuildingsResponse: null,
    getLeaseBuildingByIdResponse: null,
    deleteLeaseBuildingsResponse: null,
    getListForCommonFilterResponse: null,
    getLeaseDynamicFieldsResponse: null,
    getLeaseBuildingByIdLoading: false,
    entityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        historyPaginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        historyParams: {
            limit: 40,
            offset: 0,
            search: ""
        }
    }
};

const reducers = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_LEASE_BUILDING_REQUEST:
            return {
                ...state
            };
        case actionType.GET_LEASE_BUILDING_SUCCESS:
            return {
                ...state,
                getLeaseBuildingsResponse: { success: true, ...action.response }
            };
        case actionType.GET_LEASE_BUILDING_FAILURE:
            return {
                ...state,
                getLeaseBuildingsResponse: { success: false, ...action.error }
            };
        case actionType.ADD_LEASE_BUILDING_REQUEST:
            return {
                ...state
            };
        case actionType.ADD_LEASE_BUILDING_SUCCESS:
            return {
                ...state,
                addLeaseBuildingsResponse: { success: true, ...action.response }
            };
        case actionType.ADD_LEASE_BUILDING_FAILURE:
            return {
                ...state,
                addLeaseBuildingsResponse: { success: false, ...action.error }
            };

        case actionType.UPDATE_LEASE_BUILDING_REQUEST:
            return {
                ...state
            };
        case actionType.UPDATE_LEASE_BUILDING_SUCCESS:
            return {
                ...state,
                updateLeaseBuildingsResponse: { success: true, ...action.response }
            };
        case actionType.UPDATE_LEASE_BUILDING_FAILURE:
            return {
                ...state,
                updateLeaseBuildingsResponse: { success: false, ...action.error }
            };

        case actionType.DELETE_LEASE_BUILDING_REQUEST:
            return {
                ...state
            };
        case actionType.DELETE_LEASE_BUILDING_SUCCESS:
            return {
                ...state,
                deleteLeaseBuildingsResponse: { success: true, ...action.response }
            };
        case actionType.DELETE_LEASE_BUILDING_FAILURE:
            return {
                ...state,
                deleteLeaseBuildingsResponse: { success: false, ...action.error }
            };

        case actionType.GET_LEASE_BUILDING_BY_ID_REQUEST:
            return {
                ...state,
                getLeaseBuildingByIdLoading: true
            };
        case actionType.GET_LEASE_BUILDING_BY_ID_SUCCESS:
            return {
                ...state,
                getLeaseBuildingByIdResponse: { success: true, ...action.response },
                getLeaseBuildingByIdLoading: false
            };
        case actionType.GET_LEASE_BUILDING_BY_ID_FAILURE:
            return {
                ...state,
                getLeaseBuildingByIdResponse: { success: false, ...action.error },
                getLeaseBuildingByIdLoading: false
            };

        case actionType.GET_LEASE_BUILDING_DYNAMIC_FIELDS_REQUEST:
            return {
                ...state
            };
        case actionType.GET_LEASE_BUILDING_DYNAMIC_FIELDS_SUCCESS:
            return {
                ...state,
                getLeaseDynamicFieldsResponse: { success: true, ...action.response }
            };
        case actionType.GET_LEASE_BUILDING_DYNAMIC_FIELDS_FAILURE:
            return {
                ...state,
                getLeaseDynamicFieldsResponse: { success: false, ...action.error }
            };

        case actionType.UPDATE_LEASE_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                entityParams: { ...action.response }
            };
        case actionType.UPDATE_LEASE_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                entityParams: { ...action.error }
            };

        case actionType.GET_LIST_FOR_COMMON_FILTER_REQUEST:
            return {
                ...state
            };
        case actionType.GET_LIST_FOR_COMMON_FILTER_SUCCESS:
            return {
                ...state,
                getListForCommonFilterResponse: { success: true, ...action.response }
            };
        case actionType.GET_LIST_FOR_COMMON_FILTER_FAILURE:
            return {
                ...state,
                getListForCommonFilterResponse: { success: false, ...action.error }
            };

        case actionType.RESET_REDUCER:
            return {
                ...state,
                getLeaseBuildingByIdResponse: null,
                getLeaseDynamicFieldsResponse: null,
                getSurveyRecommendationsImagesByIdLoading: false
            };
        default:
            return state;
    }
};
export default reducers;
